/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kindle_Audio_ErrorInputs */

const en_kindle_audio_error = /** @type {(inputs: Kindle_Audio_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audio stopped loading. Tap play to retry from your place.`)
};

const es_kindle_audio_error = /** @type {(inputs: Kindle_Audio_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El audio dejó de cargar. Toca reproducir para reintentarlo desde donde estabas.`)
};

/**
* | output |
* | --- |
* | "Audio stopped loading. Tap play to retry from your place." |
*
* @param {Kindle_Audio_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const kindle_audio_error = /** @type {((inputs?: Kindle_Audio_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kindle_Audio_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_kindle_audio_error(inputs)
	return en_kindle_audio_error(inputs)
});